<template>
  <h3
    class="
      text-text text-[14px]
      h-[36px]
      font-bold
      px-300
      mb-150
      flex
      items-center
    "
  >
    <span class="flex-none flex items-center justify-center w-[45px] h-[18px]">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.2652 14.5927L14.6932 12.021C15.181 11.3937 15.4834 10.6153 15.4834 9.75916C15.4834 9.02664 15.2661 8.31058 14.8592 7.70151C14.4522 7.09245 13.8738 6.61774 13.197 6.33742C12.5203 6.0571 11.7756 5.98375 11.0572 6.12666C10.3387 6.26957 9.67878 6.6223 9.16082 7.14027C8.64285 7.65824 8.29011 8.31817 8.1472 9.03661C8.0043 9.75505 8.07764 10.4997 8.35796 11.1765C8.63828 11.8532 9.11299 12.4317 9.72206 12.8386C10.3311 13.2456 11.0472 13.4628 11.7797 13.4628C12.6347 13.4628 13.4125 13.1613 14.0395 12.6746L16.6118 15.2467C16.6333 15.2682 16.6589 15.2852 16.687 15.2969C16.7151 15.3085 16.7452 15.3145 16.7756 15.3145C16.806 15.3145 16.8361 15.3085 16.8642 15.2969C16.8923 15.2852 16.9179 15.2682 16.9394 15.2467L17.2666 14.9194C17.3096 14.8758 17.3336 14.817 17.3334 14.7558C17.3331 14.6945 17.3086 14.6359 17.2652 14.5927ZM11.7791 12.5369C11.2297 12.5369 10.6927 12.374 10.2359 12.0688C9.77909 11.7635 9.42306 11.3297 9.21282 10.8222C9.00258 10.3146 8.94757 9.75607 9.05475 9.21725C9.16193 8.67842 9.42648 8.18347 9.81496 7.79499C10.2034 7.40652 10.6984 7.14196 11.2372 7.03478C11.776 6.9276 12.3346 6.98261 12.8421 7.19285C13.3497 7.40309 13.7835 7.75912 14.0887 8.21592C14.394 8.67272 14.5569 9.20977 14.5569 9.75916C14.5559 10.4956 14.263 11.2016 13.7423 11.7223C13.2215 12.243 12.5155 12.536 11.7791 12.5369ZM10.3888 14.3887H2.05556C1.93278 14.3887 1.81502 14.34 1.7282 14.2531C1.64138 14.1663 1.5926 14.0486 1.5926 13.9258V1.89148C1.5926 1.76869 1.64138 1.65094 1.7282 1.56412C1.81502 1.4773 1.93278 1.42852 2.05556 1.42852H7.1481V4.43775C7.14783 4.52902 7.16561 4.61944 7.20041 4.70381C7.23522 4.78818 7.28636 4.86484 7.3509 4.92938C7.41543 4.99392 7.49209 5.04506 7.57647 5.07987C7.66084 5.11467 7.75126 5.13245 7.84253 5.13218L11.7777 5.12958V4.3194C11.7771 3.95043 11.6304 3.59672 11.3697 3.33562L8.94206 0.907982C8.68194 0.647231 8.3289 0.500478 7.96059 0.5H2.05556C1.68713 0.501224 1.33419 0.648301 1.07391 0.909063C0.813636 1.16983 0.66722 1.52305 0.666687 1.89148V13.9258C0.666687 14.2941 0.813014 14.6474 1.07348 14.9079C1.33394 15.1683 1.68721 15.3146 2.05556 15.3146H10.3888C10.6766 15.314 10.9571 15.2236 11.1913 15.0562C11.4254 14.8887 11.6015 14.6525 11.6952 14.3803C11.3645 14.3735 11.0354 14.3312 10.7137 14.2542C10.6275 14.3403 10.5107 14.3887 10.3888 14.3887ZM8.07401 1.44299C8.15519 1.46306 8.22928 1.5051 8.28813 1.56451L10.7158 3.99186C10.7751 4.05065 10.8171 4.12462 10.8373 4.20569H8.07401V1.44299Z"
          fill="#8F9BB3"
        />
      </svg>
    </span>
    <span class="flex-auto">
      {{ $t('Search Results') }}
    </span>
  </h3>
</template>

<script>
export default {};
</script>

<style></style>
